// Informations de contact et liens sociaux
export const CONTACT_INFO = {
  email: 'zoe.briois.pro@gmail.com',
  linkedin: {
    url: 'https://linkedin.com/in/zoebriois',
    username: 'zoebriois',
    displayUrl: 'linkedin.com/in/zoebriois'
  },
  github: {
    url: 'https://github.com/zoebriois',
    username: 'zoebriois',
    displayUrl: 'github.com/zoebriois'
  },
  gumroad: {
    url: 'https://zoebriois.gumroad.com/',
    displayUrl: 'zoebriois.gumroad.com'
  }
};

// Informations professionnelles
export const PROFILE_INFO = {
  name: 'Zoé Briois',
  title: 'Chef de Projet IT – Études & Développement',
  tagline: 'Chef de projet IT · Études & développement · Pilotage technique',
  headline: 'Je pilote des projets IT complexes, de l\'analyse des besoins à la livraison technique.',
  experience: '6 ans d\'expérience · Développement backend & pilotage IT',
  currentFocus: "Recherche active d'un poste de Chef de Projet IT ou Product Owner technique"
};
